import React, { useState, useEffect, useRef } from "react";

export const DEFAULT_DISCLAIMER_TEXT =
  "Seluruh nama, organisasi, talent, harga, rider, transaksi, tiket, dan metrik pada mode demo merupakan data fiktif untuk demonstrasi kompetisi. Pembayaran bersifat sandbox; tidak ada uang nyata yang ditagihkan.";

export function TypewriterDisclaimer({
  text = DEFAULT_DISCLAIMER_TEXT,
  speed = 12,
  className = "",
  cursorClassName = "",
}) {
  const [displayedText, setDisplayedText] = useState("");
  const [isComplete, setIsComplete] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const containerRef = useRef(null);

  // Trigger when visible in viewport
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    if (typeof IntersectionObserver !== "undefined") {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setHasStarted(true);
            observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(el);
      return () => observer.disconnect();
    } else {
      setHasStarted(true);
    }
  }, []);

  // Fast typing effect
  useEffect(() => {
    if (!hasStarted) return;

    let currentIndex = 0;
    const totalChars = text.length;

    const interval = setInterval(() => {
      currentIndex += 1;
      setDisplayedText(text.slice(0, currentIndex));

      if (currentIndex >= totalChars) {
        clearInterval(interval);
        setIsComplete(true);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [hasStarted, text, speed]);

  return (
    <span
      ref={containerRef}
      className={`inline-block transition-colors duration-300 ${
        isComplete ? "okx-text-shimmer" : "text-zinc-200"
      } ${className}`}
    >
      {displayedText}
      <span
        className={`inline-block ml-1 w-1.5 h-3.5 sm:h-4 align-middle rounded-sm bg-[#ff2e7e] shadow-[0_0_8px_rgba(255,46,126,0.7)] okx-cursor-blink ${
          isComplete ? "opacity-90" : "opacity-100"
        } ${cursorClassName}`}
        aria-hidden="true"
      />
    </span>
  );
}

export default TypewriterDisclaimer;
